/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import { SKELETON_BLOCK, skeletonSlots } from './skeleton-primitives';

export interface DashboardCardsSkeletonProps {
  /** Number of metric-card placeholders to render. */
  cards?: number;
}

/**
 * Placeholder mimicking a row of dashboard metric cards.
 *
 * @param props Number of metric cards to render.
 * @returns A shimmering dashboard-cards placeholder.
 */
export const DashboardCardsSkeleton: React.FC<DashboardCardsSkeletonProps> = ({
  cards = 4,
}) => (
  <div
    data-testid="dashboard-cards-skeleton"
    className="grid grid-cols-2 gap-4 md:grid-cols-4"
  >
    {skeletonSlots(cards).map((slot) => (
      <div
        key={slot}
        data-testid="dashboard-cards-skeleton-card"
        className="flex flex-col gap-3 rounded-(--radius-lg) border border-(--border-subtle) bg-(--surface-primary) p-5"
      >
        <div className={`${SKELETON_BLOCK} h-3 w-1/2`} />
        <div className={`${SKELETON_BLOCK} h-7 w-2/3`} />
      </div>
    ))}
  </div>
);
